import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toastifyType } from '../../constants';
import { Toaster, toast } from 'sonner'

const ToastHandler = () => {
  const dispatch = useDispatch();
  const { toastType, toastMessage } = useSelector(state => state.toast);

  useEffect(() => {
    if (toastType && toastMessage) {
      if (toastType === toastifyType.SHOW_SUCCESS_MESSAGE) {
        // toast.success(toastMessage);
        toast.success(toastMessage)
      } else if (toastType === toastifyType.SHOW_ERROR_MESSAGE) {
        // toast.error(toastMessage);
        toast.error(toastMessage)
      }

      // Clear toast
      dispatch({ type: toastifyType.SHOW_TOAST, payload: { type: null, message: '' } });
    }
  }, [toastType, toastMessage, dispatch]);

  const generateCloseColor = () => {
    if (toastType === "success") {
      return "bg-green-500";
    } else if (toastType === "error") {
      return "bg-rose-500";
    }

  }

  return <Toaster position="bottom-right" toastOptions={{
    classNames: {
      closeButton: `!right-[-12px] left-auto rounded-md border-2 !shadow-md ${generateCloseColor()}`,
      toast: "bg-white border-2 border-gray-200 text-[12px] tracking-wide shadow-md px-3 py-4",
    }
  }} richColors closeButton  />;
};

export default ToastHandler;
